import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseEvent } from 'TrainingTrackingDataTypes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CourseEventLogService {
  constructor(private http: HttpClient) {}
  /**
   * Gets all eventlogs from the database
   * @returns
   */
  getCourseEventLogs(): Observable<CourseEvent[]> {
    return this.http.get<CourseEvent[]>('/api/CourseEventLog');
  }
}
